import React from 'react'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useTranslation } from 'react-i18next'
import { Label, Title } from '../../../components/presentation/Text'

const ModalHeader = () => {
  const { t } = useTranslation('duplicates')
  const { duplicateInputs } = useModalData() || {}
  const context = duplicateInputs?.length > 1 ? 'multiple' : 'single'
  const title = t(`title_${context}`)
  const subtitle = t(`subtitle_${context}`, '')

  return (
    <>
      <Title size="h4" noMargin>
        {title}
      </Title>
      {subtitle && <Label noMargin>{`*${subtitle}*`}</Label>}
    </>
  )
}

export default ModalHeader
